module.exports = __webpack_public_path__ + "static/media/houseIcon.e5a8ec42.svg";